<template>
    <div class="h-px bg-gray-200 mx-3" />
</template>
